import React from 'react';
import PropTypes from 'prop-types';
import {
  IonButton,
  IonModal,
  IonHeader,
  IonContent,
  IonButtons,
  IonToolbar,
  IonList,
  IonLoading,
} from '@ionic/react';
import { Field, Form, Formik } from 'formik';
import AppActions from 'redux/AppRedux';
import AuthActions, { AuthSelectors } from 'redux/AuthRedux';
import api_v2 from 'services/api_v2';
import { useDispatch, useSelector } from 'react-redux';
import { InputField } from 'components/form';

function BirthdayModal({ open, onClose }) {
  const token = useSelector(AuthSelectors.selectToken);
  const dispatch = useDispatch();

  const handleSubmit = async (payload, actions) => {
    try {
      const api = api_v2(token);

      const updateParams = {
        birthday: !payload.birthday ? undefined : new Date(payload.birthday),
      };

      const updatedUser = await api.updateUser(updateParams);
      console.log(updatedUser);
      dispatch(AuthActions.setUser(updatedUser));

      dispatch(AppActions.setToast('Saved successfully', 'success'));
    } catch (e) {
      console.log(e);
      dispatch(
        AppActions.setToast(
          e.message || 'There was problem updating user',
          'danger'
        )
      );
    }

    actions.setSubmitting(false);
  };

  return (
    <IonModal isOpen={open} onDidDismiss={onClose}>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="end">
            <IonButton onClick={onClose} fill="light">
              Close
            </IonButton>
          </IonButtons>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <Formik
          initialValues={{
            birthday: '',
          }}
          onSubmit={handleSubmit}
        >
          {({ isSubmitting }) => {
            return (
              <Form>
                <IonLoading isOpen={isSubmitting} message="Loading..." />
                <IonList>
                  <Field
                    component={InputField}
                    type="date"
                    name="birthday"
                    label="Birthday"
                    placeholder="MM/DD/YYYY"
                    displayFormat="MM/DD/YYYY"
                  />
                  <div className="mb-2x mt-5x">
                    <IonButton
                      color="secondary"
                      expand="block"
                      fill="solid"
                      type="submit"
                      disabled={isSubmitting}
                    >
                      Save
                    </IonButton>
                  </div>
                </IonList>
              </Form>
            );
          }}
        </Formik>
      </IonContent>
    </IonModal>
  );
}

BirthdayModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
};

export default BirthdayModal;
